import { render, staticRenderFns } from "./VmcCrewFamilyParty2024CebuBohol.vue?vue&type=template&id=40527a1c&scoped=true"
import script from "./VmcCrewFamilyParty2024CebuBohol.vue?vue&type=script&lang=js"
export * from "./VmcCrewFamilyParty2024CebuBohol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40527a1c",
  null
  
)

export default component.exports